import { CORRESPONDENTS, CORRESPONDENT_BY_ID, CREATE_CORRESPONDENT, DELETE_CORRESPONDENT, UPDATE_CORRESPONDENT } from './actions';
import { ERROR, LOADED, LOADING } from '../../middleware/actions';
import { LOGOUT } from '../authentication/actions';

import { createReducer } from '../../utility';

const initialState = {
  createLoader: false,
  data: {},
  deleteLoader: false,
  error: '',
  loader: false,
  updateLoader: false,
  pagination: {
    page: 1,
    per_page: 10,
    total_objects: 0,
    total_pages: 0,
    links: {
      first: '',
      last: '',
      next: '',
    },
  },
};

const reducers = {
  [CORRESPONDENTS + LOADING]() {
    return {
      ...initialState,
      loader: true,
    };
  },
  [CORRESPONDENTS + LOADED](state, payload) {
    const correspondants = payload?.result?.correspondants;
    const data = correspondants?.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
    return {
      ...state,
      loader: false,
      error: '',
      data: { ...state.data, ...data },
      pagination: {
        ...state.pagination,
        ...payload?.result?.meta.pagination,
        page: payload?.originalPayload?.page,
      },
    };
  },
  [CORRESPONDENTS + ERROR](state, payload) {
    return {
      ...state,
      loader: false,
      error: payload.result,
    };
  },
  [CORRESPONDENT_BY_ID + LOADING]() {
    return {
      ...initialState,
      loader: true,
    };
  },
  [CORRESPONDENT_BY_ID + LOADED](state, payload) {
    const data = { [payload?.result?.id]: payload?.result };
    return {
      ...state,
      loader: false,
      error: '',
      data: { ...state.data, ...data },
    };
  },
  [CORRESPONDENT_BY_ID + ERROR](state, payload) {
    return {
      ...state,
      loader: false,
      error: payload.result,
    };
  },
  [CREATE_CORRESPONDENT + LOADING](state) {
    return {
      ...state,
      createLoader: true,
    };
  },
  [CREATE_CORRESPONDENT + LOADED](state, payload) {
    return {
      ...state,
      createLoader: false,
      error: null,
      data: { ...state.data, [payload?.result?.id]: payload.result },
    };
  },
  [CREATE_CORRESPONDENT + ERROR](state, payload) {
    return {
      ...state,
      createLoader: false,
      error: payload.result,
    };
  },

  [UPDATE_CORRESPONDENT + LOADING](state) {
    return {
      ...state,
      updateLoader: true,
    };
  },
  [UPDATE_CORRESPONDENT + LOADED](state, payload) {
    return {
      ...state,
      updateLoader: false,
      error: null,
      data: { ...state.data, [payload?.result?.id]: payload.result },
    };
  },
  [UPDATE_CORRESPONDENT + ERROR](state, payload) {
    return {
      ...state,
      updateLoader: false,
      error: payload.result,
    };
  },

  [DELETE_CORRESPONDENT + LOADING](state) {
    return {
      ...state,
      deleteLoader: true,
      error: null,
    };
  },
  [DELETE_CORRESPONDENT + LOADED](state, payload) {
    const newData = state.data;
    delete newData[payload?.originalPayload?.id];
    return {
      ...state,
      data: newData,
      deleteLoader: false,
      error: null,
    };
  },
  [DELETE_CORRESPONDENT + ERROR](state, payload) {
    return {
      ...state,
      deleteLoader: false,
      error: payload.result,
    };
  },

  // Reset reducers
  [LOGOUT]() {
    return initialState;
  },
  [LOGOUT + LOADED]() {
    return initialState;
  },
};

export default createReducer(reducers, initialState);
